import { alertAnatomy } from '@chakra-ui/anatomy'
import { createMultiStyleConfigHelpers } from '@chakra-ui/react'

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(alertAnatomy.keys)

const baseStyle = definePartsStyle((props) => {
  const { status } = props;

  const infoBase = status === "info" && {
    container: {
      background: 'brand.fontColorWhite',
      borderRadius: 5,
      fontSize: 'sm',
    }
  };

  const successBase = status === 'success' && {
    container: {
      background: 'linear-gradient(270deg, var(--chakra-colors-brand-gradientBlueLight) 0%, var(--chakra-colors-brand-gradientBlueDark) 100%) 0% 0%',
    }
  }

  const warningBase = status === 'warning' && {
    container: {
      background: 'linear-gradient(90deg, #ED9A33 0%, #EEA02E 10%, #F0A629 20%, #F1AD24 30%, #F3B31F 40%, #F5BA19 50%, #F7C014 60%, #F8C70F 70%, #FACD0A 80%, #FCD405 90%, #FDDB00 100%) 0% 0% no-repeat padding-box',
    }
  }

  const errorBase = status === 'error' && {
    container: {
      background: 'linear-gradient(270deg, var(--chakra-colors-brand-pink) 0%, var(--chakra-colors-brand-raspberry) 100%) 0% 0%',
    }
  }

  return {
    ...infoBase,
    ...successBase,
    ...warningBase,
    ...errorBase
  };
})

export const AlertTheme = defineMultiStyleConfig({ baseStyle })